"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** Show page links */
var Paginator =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Paginator, _React$Component);

  function Paginator() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Paginator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Paginator)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "_changePage", function (page) {
      if (page < 1 || page > _this.props.total) {
        return;
      }

      _this.props.onPageChange(page);
    });

    _defineProperty(_assertThisInitialized(_this), "_gotoPage", function (page, e) {
      e.preventDefault();

      if (page < 1 || page > _this.props.total) {
        return;
      }

      _this._changePage(page);
    });

    _defineProperty(_assertThisInitialized(_this), "_gotoPrevPage", function (e) {
      e.preventDefault();

      _this._changePage(_this.props.currentPage - 1);
    });

    _defineProperty(_assertThisInitialized(_this), "_gotoNextPage", function (e) {
      e.preventDefault();

      _this._changePage(_this.props.currentPage + 1);
    });

    _defineProperty(_assertThisInitialized(_this), "_gotoFirstPage", function (e) {
      e.preventDefault();

      _this._changePage(1);
    });

    _defineProperty(_assertThisInitialized(_this), "_gotoLastPage", function (e) {
      e.preventDefault();

      _this._changePage(_this.props.total);
    });

    return _this;
  }

  _createClass(Paginator, [{
    key: "render",
    value: function render() {
      // Don't show anything if there is only one page
      if (this.props.total <= 1) {
        return null;
      }

      var pages = [];
      var isGap = false;

      for (var i = 1; i <= this.props.total; i++) {
        // Don't show gap pages
        if (this.props.total > this.props.minPages && Math.abs(i - this.props.currentPage) > this.props.aroundPages && Math.abs(i) > this.props.edgePages && Math.abs(this.props.total - i) >= this.props.edgePages) {
          if (!isGap) {
            pages.push(_react.default.createElement("li", {
              key: i,
              className: "disabled"
            }, _react.default.createElement("a", null, "...")));
            isGap = true;
          }
        } else {
          isGap = false;
          var className = i === this.props.currentPage ? 'active' : '';
          pages.push(_react.default.createElement("li", {
            key: i,
            className: className,
            onClick: this._gotoPage.bind(null, i)
          }, _react.default.createElement("a", {
            href: "#"
          }, i)));
        }
      } // Prev and next pages


      if (this.props.isAngularLinks) {
        // Prev page
        pages.unshift(_react.default.createElement("li", {
          key: "prev",
          className: this.props.currentPage === 1 ? 'disabled' : '',
          onClick: this._gotoPrevPage
        }, _react.default.createElement("a", {
          href: "#"
        }, "\xAB"))); // Next page

        pages.push(_react.default.createElement("li", {
          key: "next",
          className: this.props.currentPage === this.props.total ? 'disabled' : '',
          onClick: this._gotoNextPage
        }, _react.default.createElement("a", {
          href: "#"
        }, "\xBB")));
      } // First and last pages


      if (this.props.isEdgeLinks) {
        // First page
        pages.unshift(_react.default.createElement("li", {
          key: "first",
          className: this.props.currentPage === 1 ? 'disabled' : '',
          onClick: this._gotoFirstPage
        }, _react.default.createElement("a", {
          href: "#"
        }, "First"))); // Last page

        pages.push(_react.default.createElement("li", {
          key: "last",
          className: this.props.currentPage === this.props.total ? 'disabled' : '',
          onClick: this._gotoLastPage
        }, _react.default.createElement("a", {
          href: "#"
        }, "Last")));
      }

      return _react.default.createElement("ul", {
        className: (0, _classnames.default)('pagination', 'pagination-sm', _style.default.paginator, this.props.className)
      }, pages);
    }
  }]);

  return Paginator;
}(_react.default.Component);

exports.default = Paginator;

_defineProperty(Paginator, "propTypes", {
  /** total number of pages. If equal 0 then the component shows nothing */
  total: _propTypes.default.number,

  /** current page */
  currentPage: _propTypes.default.number,

  /** minimum number of pages around the current page */
  aroundPages: _propTypes.default.number,

  /** minimum number of pages at the beggining and at the end */
  edgePages: _propTypes.default.number,

  /** show "Next" and "Prev" links or not? */
  isAngularLinks: _propTypes.default.bool,

  /** show "First" and "Last" links or not? */
  isEdgeLinks: _propTypes.default.bool,

  /** minimum number of pages which will not be splitted */
  minPages: _propTypes.default.number,

  /** function called after changing page. With params: function(newPage) */
  onPageChange: _propTypes.default.func,

  /** Additional wrapper class name */
  className: _propTypes.default.string
});

_defineProperty(Paginator, "defaultProps", {
  total: 0,
  currentPage: 1,
  aroundPages: 3,
  edgePages: 1,
  isAngularLinks: false,
  isEdgeLinks: false,
  minPages: 10,
  onPageChange: function onPageChange() {},
  className: ''
});